import { MarkerPropertiesInterface } from "modules/construction-work/src/Common/interface";
import {
    Map,
    Marker,
    VectorLayer,
} from "maptalks";
import GeometryRendererAbstract from 'modules/construction-work/src/Entity/Map/GeometryRendererAbstract'

export default class MarkerRenderer extends GeometryRendererAbstract {
    render(geometry: Marker, markerLayer: VectorLayer, map: Map): void {
        const properties = (geometry as any).properties as MarkerPropertiesInterface;

        let svgMap = properties.settingsMarker?.svgMap;

        if (!svgMap){
            svgMap = properties.settingsMarker?.imgMap;
        }

        if (svgMap) {
            const markerSymbols = this.buildMarkerSymbols(
                properties,
            );

            geometry.setSymbol(markerSymbols);
            markerLayer.addGeometry(geometry);
        }
    }
}
